export default "__VITE_ASSET__ZT_0I5l8__"